var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-level flex-top" }, [
    _c(
      "div",
      { staticClass: "flex flex-row" },
      [
        _c("avatar", { attrs: { avatar: _vm.third.avatar, size: "big" } }),
        _vm._v(" "),
        _c("div", { staticClass: "dinlineb valign-middle ml-3" }, [
          _c(
            "h4",
            { staticClass: "mt-0 mb-1" },
            [
              _c("CompassLink", {
                attrs: {
                  label: _vm.third.name,
                  link: "/thirds/" + _vm.third.relationType + "/" + _vm.third.id
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.third.type
            ? _c("span", { staticClass: "fs-3 gray-60 capitalize" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.relationTypeTranslated) +
                    "\n            "
                )
              ])
            : _vm._e()
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex" }, [
      _c("ul", { staticClass: "m-0" }, [
        _vm.third.email !== ""
          ? _c(
              "li",
              { staticClass: "mb-1 fs-3 mb-1 copy-element" },
              [
                _c("i", { staticClass: "icon-email mr-2 gray-60" }),
                _vm._v(" "),
                _c(
                  "email-link",
                  {
                    staticClass: "regular",
                    attrs: {
                      linkedtype: "third",
                      linkedid: parseInt(_vm.third.id),
                      disabled: _vm.third.isArchived,
                      email: _vm.third.email
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.third.email) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("SaasClipboard", {
                  attrs: { data: _vm.third.email, tooltipPlacement: "right" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.third.phone !== ""
          ? _c(
              "li",
              { staticClass: "mb-1 fs-3 mb-1 copy-element" },
              [
                _c("i", { staticClass: "icon-sellsyphone mr-2 gray-60" }),
                _vm._v(" "),
                _c("CompassLink", {
                  attrs: {
                    label: _vm.third.phone,
                    link:
                      _vm.phonecallProtocol +
                      ":" +
                      _vm.third.phone.replace(/[^\+\d]/g, "")
                  }
                }),
                _vm._v(" "),
                _c("SaasClipboard", {
                  attrs: { data: _vm.third.phone, tooltipPlacement: "right" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.third.mobile !== ""
          ? _c(
              "li",
              { staticClass: "mb-1 fs-3 mb-1 copy-element" },
              [
                _c("i", { staticClass: "icon-sellsyphone mr-2 gray-60" }),
                _vm._v(" "),
                _c("CompassLink", {
                  attrs: {
                    label: _vm.third.mobile,
                    link:
                      _vm.phonecallProtocol +
                      ":" +
                      _vm.third.mobile.replace(/[^\+\d]/g, "")
                  }
                }),
                _vm._v(" "),
                _c("SaasClipboard", {
                  attrs: { data: _vm.third.mobile, tooltipPlacement: "right" }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-dropdown",
          {
            scopedSlots: _vm._u([
              {
                key: "dropdown",
                fn: function() {
                  return [
                    _c(
                      "el-dropdown-menu",
                      _vm._l(_vm.third.actions, function(action, index) {
                        return _c(
                          "el-dropdown-item",
                          {
                            key: index,
                            class: !_vm.hasAccess(
                              action.permission,
                              _vm.permissions
                            )
                              ? "link-disabled"
                              : "",
                            attrs: {
                              disabled: !_vm.hasAccess(
                                action.permission,
                                _vm.permissions
                              )
                            }
                          },
                          [
                            action.type === "vuejs"
                              ? _c(
                                  "a",
                                  {
                                    class: !_vm.hasAccess(
                                      action.permission,
                                      _vm.permissions
                                    )
                                      ? "link-disabled"
                                      : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit(
                                          "clicked",
                                          action.value,
                                          _vm.third
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(action.label) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              : _c(
                                  "a",
                                  {
                                    class: !_vm.hasAccess(
                                      action.permission,
                                      _vm.permissions
                                    )
                                      ? "link-disabled"
                                      : "",
                                    attrs: { href: action.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(action.label) +
                                        "\n                        "
                                    )
                                  ]
                                )
                          ]
                        )
                      }),
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          },
          [
            _c(
              "a",
              { staticClass: "btn-icon", attrs: { href: "javascript:;" } },
              [_c("i", { staticClass: "icon-burger" })]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }